import axios from "axios";
import Swal from "sweetalert2";
import LocalStorageService from "./localStorageService";
import { Redirect } from "react-router-dom";
export const baseURL = "https://esignapi.robi.com.bd";
// export const baseURL = window.baseURL;
const loginURL = baseURL + "/oauth/token";
const logoutURL = "/oauth/revoke";

const client_id = "my-trusted-client";
// const client_id = "my-trusted-client";
const client_secret = "secret";
// const CallBackURL = process.env.PUBLIC_URL + "/signing-signing-status";
// const client_secret = "secret";

const caxios = axios.create({
  baseURL: baseURL,
  timeout: window.timeout,
});

// LocalstorageService
const localStorageService = LocalStorageService.getService();

window.addEventListener("onLine", () => {
  console.log("Online");
});
window.addEventListener("offLine", () => {
  console.log("Offline");
});
// console.log("windownavigator", window.navigator.onLine);

export const errorCompute2 = (msg, redirection) => {
  console.log("windownavigator", window.navigator.onLine, msg);
  window.navigator.onLine && msg !== undefined
    ? Swal.fire({
      title: `${""}`,
      icon: "error",
      html: `${msg}`,
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      showConfirmButton: false,
      // confirmButtonText: "Okay",
      // confirmButtonAriaLabel: "Okay",
      cancelButtonText: "Okay",
      cancelButtonAriaLabel: "Okay",
    }).then(function (result) {
      if (result.value) {
        {
          if (redirection) {
            console.log("redirection", redirection);
            window.location = redirection;
          } else {
            window.location = "/login";
          }
        }
      }
    })
    : Swal.fire({
      title: `<strong>${msg === undefined ? "Network Error" : msg}</strong>`,
      icon: "error",
      html: `<b>You are currently offline. Please check the internet.</b>`,
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      showConfirmButton: false,
      // confirmButtonText: "Okay",
      // confirmButtonAriaLabel: "Okay",
      cancelButtonText: "Okay",
      cancelButtonAriaLabel: "Okay",
    }).then(function (result) {
      if (result.value) {
        {
          if (redirection) {
            console.log("redirection", redirection);
            window.location = redirection;
          } else {
            window.location = "/login";
          }
        }
      }
    });
};

// Add a request interceptor
caxios.interceptors.request.use(
  (config) => {
    const token = localStorageService.getAccessToken();
    if (token && config.url !== loginURL) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    // config.headers['Content-Type'] = 'application/json';
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

//Add a response interceptor

caxios.interceptors.response.use(
  (response) => {
    //console.log("response", response);
    if (response.status === 200 && response.config.url === loginURL) {
      localStorageService.setToken(response.data);
    }
    return response;
  },
  function (error) {
    const originalRequest = error.config;

    console.log(error.config, error?.response?.data);

    if (!error.response) {
      console.log("!error.response", error);
      return Promise.reject(error);
    }

    if (error.response.status === 401 && originalRequest.url === loginURL) {
      //router.push('/login');
      console.log("error 401", error);
      return Promise.reject(error);
    }

    if (error.response.status === 401 && originalRequest.url === logoutURL) {
      localStorageService.clearToken();
      localStorage.setItem("loggedIn", false);
      window.location = `${process.env.PUBLIC_URL}/login`;
      return Promise.reject(error);
    }

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      let token = getBasicToken();
      const rtoken = localStorageService.getRefreshToken();
      const deviceModel = localStorage.getItem("deviceModel");
      const platform = localStorage.getItem("platform");
      const deviceId = localStorage.getItem("deviceId");
      const os = localStorage.getItem("os");
      let reqData = {
        grantType: "refresh_token",
        clientId: client_id,
        refreshToken: rtoken,
        deviceInfo: {
          deviceModel: deviceModel,
          os: os,
          platform: platform,
          language: "en-US",
          deviceId: deviceId,
        },
      };
      let config = {
        headers: {
          Authorization: `Basic ${token}`,
          //'Content-Type': 'application/x-www-form-urlencoded'
        },
      };
      return axios
        .post(loginURL, reqData, config)
        .then((res) => {
          if (res.status === 200) {
            localStorageService.setToken(res.data);
            //axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorageService.getAccessToken();
            return caxios(originalRequest);
          } else {
            localStorageService.clearToken();
          }
        })
        .catch(function (err) {
          // 26/07/20-e nazmun-er sathe discussion
          localStorageService.clearToken();
          localStorage.setItem("loggedIn", false);
          window.location = `${process.env.PUBLIC_URL}/login`;
          return Promise.reject(err);
        });
    }
    if (window.navigator.onLine) {
      if (error?.response?.data?.error_description) {
        errorCompute2(error?.response?.data?.error_description, "/login");
      } else {
        errorCompute2(error.message, "/login");
      }
    }
    console.log("error out side", error);
    return Promise.reject(error);
  }
);

function getBasicToken() {
  let temp = client_id + ":" + client_secret;
  let token = btoa(temp);

  return token;
}

export function login(userId, password, callback) {
  let reqData = `grant_type=password&username=${userId}&password=${password}&client_id=${client_id}`;
  let token = getBasicToken();
  let config = {
    headers: {
      Authorization: `Basic ${token}`,
      //'Content-Type': 'application/x-www-form-urlencoded'
    },
  };
  caxios.post("/oauth/token", reqData, config).then((res) => callback(res));
}

//export default caxios, login;
export default caxios;

//sample
//import -
//import api, {login} from './service/ApiService';
//login -
//login(cuser,cpass, (response) => {
//  console.log(response);
//})
//get -
// api.get(<url>)
// .then(res => {
//   console.log(res);
// })
//post -
//api.post(<url>, data, config)
//  .then(res => {
//     console.log(res);
//   })

